/* tslint:disable:max-line-length */
import { TestBed } from '@angular/core/testing';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { TranslateConfigService } from 'app/services/translate-config.service';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title : "navigation.dashboard.label",
        type    : 'group',
        icon    : 'heroicons_outline:home',
        hidden: () => true,
        children: [
            {
                id   : 'dashboards.analytics',
                title: 'navigation.dashboard.analyticsLabel',
                type : 'basic',
                icon : 'mat_outline:dashboard',
                link : '/dashboards/analytics',
                hidden: () => true,
            }
        ]
    },
    //Applications Menu
    {
        id      : 'apps',
        title   : 'navigation.applications.label',
        type    : 'group',
        icon    : 'heroicons_outline:cloud',
        hidden: () => true,
        children: [
            {
                id   : 'apps.print',
                title: 'navigation.applications.print.label',
                type : 'basic',
                icon : 'heroicons_outline:printer',
                link : '/print/printRelease',
                hidden: () => true,
            },
        ]
    },

    // User portal Menu

    {
        id      : 'userPortal',
        title : 'userPortal.label',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        hidden: () => true,
        children: [
            {
                id   : 'userPortal.details',
                icon : 'heroicons_outline:home',
                title: 'userPortal.userDetails.label',
                type : 'basic',
                link : '/user-details',
                hidden: () => true,
            },
            {
                id   : 'userPortal.prices',
                icon    : 'heroicons_outline:currency-dollar',
                title: 'userPortal.prices.label',
                type : 'basic',
                link : '/prices',
                hidden: () => true,
            },
            {
                id   : 'userPortal.transactions',
                icon    : 'heroicons_solid:document-report',
                title: 'userPortal.transactions.label',
                type : 'basic',
                link : '/transactions',
                hidden: () => true,
            },
            {
                id   : 'userPortal.usage',
                icon    : 'heroicons_outline:document-report',
                title: 'userPortal.usage.label',
                type : 'basic',
                link : '/usage',
                hidden: () => true,
            },
            {
                id   : 'userPortal.printRelease',
                icon    : 'mat_outline:print',
                title: 'printRelease.printButtonLabel',
                type : 'basic',
                link : '/print-release',
                hidden: () => true,
            },
            {
                id   : 'userPortal.addValue',
                icon    : 'heroicons_outline:credit-card',
                title: 'userPortal.addValue.label',
                type : 'basic',
                link : '/add-value',
                hidden: () => true,
            },
        ]
    },    //Reports Menu
    {
        id      : 'reports',
        title   : 'navigation.reports.label',
        type    : 'group',
        icon    : 'heroicons_outline:document-report',
        hidden: () => true,
        children: [
            {
                id   : 'reports.usage',
                title: 'navigation.reports.reportsLabel',
                type : 'collapsable',
                icon : 'heroicons_outline:chart-square-bar',
                link : '/reports/usage',
                hidden: () => true,
                children: [
                    {
                        id   : 'reports.reports.executiveReports',
                        title: 'navigation.reports.executiveReportslabel',
                        type : 'basic',
                        link : '/report/executiveReports',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        }
                    },
                    {
                        id   : 'reports.reports.printerReports',
                        title: 'navigation.reports.printerReportsLabel',
                        type : 'basic',
                        link : '/report/printerReports',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        }
                    },
                    {
                        id   : 'reports.reports.csv-exports',
                        title: 'reports.csvReports',
                        type : 'basic',
                        link : '/report/csv-exports',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        }
                    },
                    {
                        id   : 'reports.reports.license-reports',
                        title: 'navigation.reports.licenseReportsLabel',
                        type : 'basic',
                        link : '/report/license-reports',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        }
                    },
                    {
                        id   : 'reports.reports.add-value-reports',
                        title: 'navigation.reports.addedValueReportsLabel',
                        type : 'basic',
                        link : '/report/value-added-reports',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        }
                    },
                    {
                        id   : 'reports.reports.kiosk-reports',
                        title: 'navigation.reports.kioskReportsLabel',
                        type : 'basic',
                        link : '/report/kiosk-transaction-reports',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        }
                    },
                    {
                        id : 'reports.reports.kiosk-payment-transaction-reports',
                        title: 'navigation.reports.kioskTransactionReportsLabel',
                        type : 'basic',
                        link : '/report/kiosk-payment-transaction-reports',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        }
                    }
                ]
            }
        ]
    },
    //Management Menu
    {
        id      : 'management',
        title   : 'navigation.management.label',
        type    : 'group',
        icon    : 'heroicons_outline:collection',
        hidden: () => true,
        children: [
            {
                id   : 'management.customer',
                title: 'navigation.management.customersLabel',
                type : 'basic',
                icon : 'heroicons_outline:office-building',
                link : '/customers/customerList',
                activeMatchPath: '/customers',
                hidden: () => true,
                children: [
                ]
            },
            {
                id   : 'management.location',
                title: 'navigation.management.locationsLabel',
                type : 'basic',
                icon : 'heroicons_outline:map-pin',
                link : '/locations/locationList',
                hidden: () => true,
                children: [
                ]
            },
            {
                id   : 'management.users',
                title: 'navigation.management.usersLabel',
                type : 'basic',
                icon : 'heroicons_outline:user',
                link : '/users',
                hidden: () => true,
                children: [
                ]
            },
            {
                id   : 'management.groups',
                title: 'navigation.management.groupsLabel',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/groups',
                hidden: () => true,
                children: [
                ]
            },
            {
                id   : 'management.accounts',
                title: 'accountLabel',
                type : 'basic',
                icon : 'heroicons_outline:user-circle',
                link : '/accounts',
                hidden: () => true,
                children: [
                ]
            }
        ]
    },
    //Things Menu
    {
        id      : 'things',
        title   : 'navigation.things.label',
        type    : 'group',
        icon    : 'heroicons_outline:puzzle',
        hidden: () => true,
        children: [
            {
                id   : 'things.thing',
                title: 'navigation.things.thingLabel',
                type : 'basic',
                icon : 'heroicons_outline:squares-plus',
                link : '/things/thingList',
                hidden: () => true,
                children: [
                ]
            },
            {
                id   : 'things.device',
                title: 'navigation.things.devicesLabel',
                type : 'basic',
                icon : 'mat_outline:devices_other',
                link : '/things/deviceList',
                hidden: () => true,
                children: [
                ]
            }
        ]
    },
    //Configuration Menu
    {
        id      : 'config',
        title   : 'navigation.configuration.label',
        type    : 'group',
        icon    : 'heroicons_outline:cog',
        hidden: () => true,
        children: [
            {
                id   : 'config.permissions',
                title: 'navigation.configuration.permission.label',
                type : 'basic',
                icon : 'heroicons_outline:key',
                link : '/config/roles',
                hidden: () => true,
                children: [
                ]
            },
            {
                id   : 'config.customization',
                title: 'navigation.configuration.customization.label',
                type : 'collapsable',
                icon : 'heroicons_outline:pencil-square',
                link : '/config/customization',
                hidden: () => true,
                children: [
                    {
                        id   : 'config.customization.upload',
                        title: 'uploadPageLabel',
                        type : 'basic',
                        link : '/config/customization/upload',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                ]
            },
            {
                id   : 'config.payment',
                title: 'navigation.configuration.paymentGateway.label',
                type : 'basic',
                icon : 'heroicons_outline:banknotes',
                link : '/payment-gateway',
                hidden: () => true,
                children: [
                ]
            },
            {
                id   : 'config.settings',
                title: 'settingsLabel',
                type : 'collapsable',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/config/settings',
                hidden: () => true,
                children: [
                    {
                        id   : 'config.settings.identity-provider',
                        title: 'authProviders.label',
                        type : 'basic',
                        link : '/config/settings/identity-provider',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.generate-api-key',
                        title: 'navigation.configuration.customization.generateApiKeyLabel',
                        type : 'basic',
                        link : '/config/settings/generate-api-key',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.jobList',
                        title: 'joblistSettingsLabel',
                        type : 'basic',
                        link : '/config/settings/jobList',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.profiles',
                        title: 'profilesLabel',
                        type : 'basic',
                        link : '/config/settings/profile',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.softwareUpdate',
                        title: 'softwareUpdateLabel',
                        type : 'basic',
                        link : '/config/settings/software-udpate',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.custom-text',
                        title: 'navigation.configuration.customization.customTextKeyLabel',
                        type : 'basic',
                        link : '/config/settings/custom-text',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.audit-logs',
                        title: 'navigation.configuration.auditLogs.auditLogLabel',
                        type : 'basic',
                        link : '/config/settings/logs',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.mobile-configuration',
                        title: 'navigation.configuration.mobileConfiguration.label',
                        type : 'basic',
                        link : '/config/settings/mobile-configuration',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                    {
                        id   : 'config.settings.terms-of-use',
                        title: 'navigation.configuration.termsOfUse.label',
                        type : 'basic',
                        link : '/config/settings/terms-of-use',
                        hidden: () => true,
                        meta: {
                            isAddEditDisabled: false
                        },
                    },
                ]
            },
            {
                id   : 'config.thirdparty',
                title: 'navigation.configuration.thirdPartySoftware.label',
                type : 'basic',
                icon : 'heroicons_outline:link',
                link : '/third-party-software',
                hidden: () => true,
                children: [
                ]
            }
        ]
    },
    //Licenses Menu
    {
        id      : 'licenses',
        title   : 'navigation.license.label',
        type    : 'group',
        icon    : 'heroicons_outline:document-text',
        link : '/licenses/license',
        hidden: () => true,
        children: [
            {
                id   : 'licenses.license',
                title: 'navigation.license.licenseLabel',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-list',
                link : '/licenses/licenseList',
                hidden: () => true,
            }
        ]
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'navigation.dashboard.label',
        tooltip : 'navigation.dashboard.dashboardTooltip',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'navigation.appsLabel',
        tooltip : 'navigation.appsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:cloud',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'userPortal',
        title: 'userPortal.label',
        type: 'aside',
        icon: 'heroicons_outline:home',
        hidden: () => true,
        children: []
    },
    {
        id      : 'reports',
        title   : 'navigation.reports.reportsLabel',
        tooltip : 'navigation.reports.reportsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:document-report',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'management',
        title   : 'navigation.management.managementLabel',
        tooltip : 'navigation.management.managementLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:collection',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'things',
        title   : 'navigation.things.thingsLabel',
        tooltip : 'navigation.things.thingsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:puzzle',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'config',
        title   : 'navigation.configuration.configurationLabel',
        tooltip : 'navigation.configuration.configurationLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:cog',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'licenses',
        title   : 'navigation.license.licensesLabel',
        tooltip : 'navigation.license.licensesLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:document-text',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'navigation.dashboard.label',
        tooltip : 'navigation.dashboard.dashboardTooltip',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'navigation.appsLabel',
        tooltip : 'navigation.appsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:cloud',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'userPortal',
        title: 'userPortal.label',
        type: 'group',
        icon: 'heroicons_outline:home',
        hidden: () => true,
        children: []
    },
    {
        id      : 'reports',
        title   : 'navigation.reports.reportsLabel',
        tooltip : 'navigation.reports.reportsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:document-report',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'management',
        title   : 'navigation.management.managementLabel',
        tooltip : 'navigation.management.managementLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:collection',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'things',
        title   : 'navigation.things.thingsLabel',
        tooltip : 'navigation.things.thingsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:puzzle',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'config',
        title   : 'navigation.configuration.configurationLabel',
        tooltip : 'navigation.configuration.configurationLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:cog',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'licenses',
        title   : 'navigation.license.licensesLabel',
        tooltip : 'navigation.license.licensesLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:document-text',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'navigation.dashboard.label',
        tooltip : 'navigation.dashboard.dashboardTooltip',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'navigation.appsLabel',
        tooltip : 'navigation.appsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:cloud',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'userPortal',
        title: 'userPortal.label',
        type: 'group',
        icon: 'heroicons_outline:home',
        hidden: () => true,
        children: []
    },
    {
        id      : 'reports',
        title   : 'navigation.reports.reportsLabel',
        tooltip : 'navigation.reports.reportsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:document-report',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'management',
        title   : 'navigation.management.managementLabel',
        tooltip : 'navigation.management.managementLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:collection',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'things',
        title   : 'navigation.things.thingsLabel',
        tooltip : 'navigation.things.thingsLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:puzzle',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'config',
        title   : 'navigation.configuration.configurationLabel',
        tooltip : 'navigation.configuration.configurationLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:cog',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'licenses',
        title   : 'navigation.license.licensesLabel',
        tooltip : 'navigation.license.licensesLabel',
        type    : 'aside',
        icon    : 'heroicons_outline:document-text',
        hidden: () => true,
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];

